import { EComboItemType } from "../../Enum/EComboItemType"

export class ComboItemReference {
  itemType: EComboItemType
  
  itemId: number

  quantity: number

  constructor(data: Partial<ComboItemReference> = {}) {

    this.itemType = data.itemType ?? EComboItemType.Product

    this.itemId = data.itemId ?? -1

    this.quantity = data.quantity ?? 1
  }
}
